module.exports = __webpack_public_path__ + "img/half_year_zm.046f65bc.jpg";